import { getNumericFontSize, getVSMFontSize } from '../../plugins/common'

/**
 * Patient_16용 스타일 resolver
 */
export const getStyles16 = ({ viewType, oneBed, isBedNumberBig, isVSM }) => ({
    type:        isVSM ? getVSMFontSize(viewType, 'type', false, isBedNumberBig)        : getNumericFontSize(viewType, 'type'),
    unit:        isVSM ? getVSMFontSize(viewType, 'unit', false, isBedNumberBig)        : getNumericFontSize(viewType, 'unit'),
    value:       isVSM ? getVSMFontSize(viewType, 'value', false, isBedNumberBig)       : getNumericFontSize(viewType, 'value'),
    alarmString: isVSM ? getVSMFontSize(viewType, 'alarmString', false, isBedNumberBig) : getNumericFontSize(viewType, 'alarmString'),
    nibpValue:   isVSM ? getVSMFontSize(viewType, 'nibpValue', false, isBedNumberBig)   : getNumericFontSize(viewType, 'nibpValue'),
    nibpSubValue:isVSM ? getVSMFontSize(viewType, 'nibpSubValue', false, isBedNumberBig): getNumericFontSize(viewType, 'nibpSubValue'),
    nibpAlarm:   isVSM ? getVSMFontSize(viewType, 'nibpAlarm', false, isBedNumberBig)   : getNumericFontSize(viewType, 'nibpAlarm'),
    gasType:     { fontSize: 11, lineHeight: '15.4px' },  // 16도 함수에서 나오지만 동일하게
    gasValue:    getNumericFontSize(viewType, 'gasValue'),
    containerMaxWidth: undefined,  // 16은 제한 없음
})

/**
 * Patient_32용 스타일 resolver
 */
export const getStyles32 = ({ patientCnt, isVSM }) => ({
    type:        isVSM ? getVSMFontSize(patientCnt, 'type', true)        : { fontSize: 14, lineHeight: '15.4px', fontWeight: 400 },
    unit:        isVSM ? getVSMFontSize(patientCnt, 'unit', true)        : { fontWeight: 200, fontSize: 12, lineHeight: '13.2px' },
    value:       isVSM ? getVSMFontSize(patientCnt, 'value', true)       : { fontSize: 55, lineHeight: '55px', letterSpacing: '-2px', fontWeight: 400 },
    alarmString: isVSM ? getVSMFontSize(patientCnt, 'alarmString', true) : { fontSize: 14, lineHeight: '15.4px', fontWeight: 400 },
    nibpValue:   isVSM ? getVSMFontSize(patientCnt, 'nibpValue', true)   : { fontSize: 22, lineHeight: '22px', letterSpacing: '-2px' },
    nibpSubValue:isVSM ? getVSMFontSize(patientCnt, 'nibpSubValue', true): { fontSize: 18, lineHeight: '19.8px' },
    nibpAlarm:   isVSM ? getVSMFontSize(patientCnt, 'nibpAlarm', true)   : { fontSize: 10, lineHeight: '13.2px' },
    gasType:     { fontSize: 11, lineHeight: '15.4px' },
    gasValue:    { fontSize: 10, lineHeight: '12.3px' },
    bisType:     { fontSize: 14, lineHeight: '15.4px' },
    bisValue:    { fontSize: 14, lineHeight: '15.4px' },
    containerMaxWidth: '33.33%',  // 32는 non-VSM에서 maxWidth 제한
})